import { Link, RichTextExt, markPluginConstructor, plugins, types } from "react-bricks/frontend"

import React from "react"
import { RenderElementProps } from "slate-react"
import { SupIcon } from "../components/svg"

export interface TableCellProps {
    isHeader?: boolean
}

const TableCell: types.Brick<TableCellProps> = ({ isHeader }) => {
    const { link, bold } = plugins

    const sup = markPluginConstructor({
        name: "sup",
        label: "Superscript",
        render: ({ children }) => <sup>{children}</sup>,
        icon: SupIcon,
    })

    const commonPlugins: types.RichTextPlugin[] = [
        {
            ...link,
            renderElement: ({ children, element, attributes }: RenderElementProps) => (
                <Link
                    {...attributes}
                    href={element.data?.url || element.url}
                    target={element.data?.isTargetBlank ? "_blank" : undefined}
                    rel={element.data?.isTargetBlank ? "noopener" : undefined}
                    className="link hover:[&_sup]:underline [&:not(:has(sup))]:underline"
                >
                    {children}
                </Link>
            ),
        },
        sup,
    ]

    return isHeader ? (
        <th className="border-r border-solid border-border-tide p-2.5 text-left font-semibold whitespace-pre-wrap first:pl-6.25 last:border-r-0 last:pr-6.25 sm:px-2.5 sm:first:pl-5 sm:last:pr-5 md:p-5 lg:px-7.5 lg:first:pl-7.5 lg:last:pr-7.5 xl:px-10 xl:py-7 xl:first:pl-10 xl:last:pr-10">
            <RichTextExt
                propName="cellText"
                placeholder="Insert text"
                renderBlock={({ children }) => <>{children}</>}
                plugins={commonPlugins}
            />
        </th>
    ) : (
        <td className="border-r border-solid border-border-tide p-2.5 text-left align-top whitespace-pre-wrap first:pl-6.25 last:border-r-0 last:pr-6.25 sm:px-2.5 sm:first:pl-5 sm:last:pr-5 md:p-5 lg:px-7.5 lg:first:pl-7.5 lg:last:pr-7.5 xl:px-10 xl:py-7 xl:first:pl-10 xl:last:pr-10">
            <RichTextExt
                propName="cellText"
                placeholder="Insert text"
                renderBlock={({ children }) => <>{children}</>}
                plugins={[
                    ...commonPlugins,
                    {
                        ...bold,
                        renderLeaf: ({ children, attributes }) => (
                            <strong {...attributes} className="font-semibold">
                                {children}
                            </strong>
                        ),
                    },
                ]}
            />
        </td>
    )
}

TableCell.schema = {
    name: "TableCell",
    label: "Cell",
    hideFromAddMenu: true,
}

export default TableCell
